import {ClassNamesConfig, components, ControlProps, GroupBase} from 'react-select'
import {cn} from 'src/app/utils/cn.utils'
import GIcon from '../../Libs/Icon/GIcon'

export const SelectedValue = ({selected, handleRemoveValue}: any) => {
  return (
    <div className='flex flex-wrap gap-2 mt-3'>
      {selected.map((data: any) => (
        <div
          key={data.value}
          className='flex items-center justify-between p-2 font-medium border rounded-lg bg-neutral-50 border-neutral-200 text-neutral-600 text-fs-10'
        >
          {data.label}{' '}
          <div onClick={() => handleRemoveValue(data.value)}>
            <GIcon icon='IconClose' className='w-4 h-4 ml-2 cursor-pointer' />
          </div>
        </div>
      ))}
    </div>
  )
}

const Control = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  children,
  isFocused,
  isDisabled,
  ...rest
}: ControlProps<Option, IsMulti, Group>) => (
  <components.Control
    className={cn('shadow-none min-h-[44px]', {
      focus: isFocused,
      disabled: isDisabled,
    })}
    isFocused
    isDisabled
    {...rest}
  >
    {children}
  </components.Control>
)

const NoOptionsMessage = (props: any) => {
  return (
    <components.NoOptionsMessage {...props}>
      <div className='font-medium text-start'>Data tidak ditemukan</div>
    </components.NoOptionsMessage>
  )
}

const Option = (props: any) => (
  <components.Option {...props} className='bg-white'>
    <div className='flex items-center justify-between pl-4'>
      <p className='overflow-ellips-2 w-fit'>{props.label}</p>

      {props.isSelected && <GIcon icon='IconCheck' className='w-5 h-5' />}
    </div>
  </components.Option>
)

export const CustomReactMultiSelect = {
  Control,
  NoOptionsMessage,
  Option,
}

export const hardClassName: ClassNamesConfig<any, boolean, any> = {
  container: () => 'bg-white w-full',
  placeholder: () => 'text-neutral-400 font-normal',
  control: () =>
    'text-fs-9 rounded-lg font-medium text-neutral-700 border-neutral-300 hover:border-neutral-300 bg-neutral-50',
  valueContainer: (state) => `min-h-0 px-4 ${state.isMulti ? 'py-0 h-11' : 'py-3'}`,
  input: () => 'm-0 p-0 text-neutral-700 font-normal',
  dropdownIndicator: (state) =>
    `transition-transform duration-150 ${state.selectProps.menuIsOpen ? 'rotate-180' : 'rotate-0'}`,
  indicatorsContainer: () => 'hidden',
  option: (state) =>
    `text-fs-9 rounded px-2 py-3 cursor-pointer ${
      state.isFocused ? 'text-primary-500' : 'text-[#495057]'
    } ${state.isDisabled ? 'text-neutral-300' : 'text-[#495057]'}`,
  menuList: () => 'max-h-[300px] w-full',
  menu: () => 'relative w-[350px] -translate-x-4 mt-[17px] rounded-none shadow',
  menuPortal: () => 'z-[999999]',
}
